module.exports = __webpack_public_path__ + "static/levercode-stack-29445fe41c5b730696e5047d7bd05cd1.png";